import styled from 'styled-components';

import { color, font } from '@creditornot/cb-ingredients/design-tokens';
import { clsx } from '@creditornot/cb-utils';
import { MeasurementUnit } from 'common/api-types/common';
import { useFormatMessage } from 'common/hooks/useFormatMessage';
import { isNil } from 'common/utils/isNil';

const Text = styled.span`
  font: ${font.body};
  white-space: nowrap;

  &.previous-quantity {
    text-decoration-line: line-through;
    color: ${color.textSubdued};
    margin-left: 8px;
  }
`;

type Props = {
  quantity: number | undefined | null;
  measurementUnit: MeasurementUnit | undefined;
  isPreviousQuantity?: boolean;
};

export const InventoryQuantity = ({
  quantity,
  measurementUnit = 'UNITS',
  isPreviousQuantity,
}: Props) => {
  const f = useFormatMessage();

  if (isNil(quantity)) {
    return (
      <Text
        data-test-id="inventory-quantity"
        className={clsx(isPreviousQuantity && 'previous-quantity')}
      >
        {f('common.unknown')}
      </Text>
    );
  }

  return (
    <Text
      data-test-id="inventory-quantity"
      className={clsx(isPreviousQuantity && 'previous-quantity')}
    >
      {f('warehouse.common.quantity_with_measurement_unit', {
        quantity,
        measurementUnit: f(`warehouse.measurement_unit:${measurementUnit}`, {
          count: quantity,
        }),
      })}
    </Text>
  );
};
